var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('codemirror',{ref:"myCm",staticClass:"appup-code",attrs:{"id":_vm.id,"value":_vm.editorCode,"options":_vm.cmOptions},on:{"ready":_vm.onCmReady,"focus":_vm.onCmFocus,"input":_vm.onCmCodeChange}})}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/code/code.vue